/*
  The link to one slab's grade report.

  It carries the shared LINK class (D25): index.css's global `a` rule is gone, so a link
  that declares nothing renders in the body colour and stops looking like a link at all.
  The style lives here rather than at each call site because there is one of these.
*/

import { Link } from 'react-router-dom';

import { LINK } from 'components/styles';

interface GradeReportLinkProps {
  gradedId: string;
  onClick?: any;
}

const GradeReportLink = ({gradedId, onClick = null} : GradeReportLinkProps) => {
  return (
    <Link to={`/report/${gradedId}`} onClick={onClick} className={LINK}>{gradedId}</Link>
  )
}

export default GradeReportLink;
